exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.v-card__title[data-v-04cf5410] {\n  max-height: 48px;\n}\n/*# sourceMappingURL=src/components/modal_babel.css.map */", "", {"version":3,"sources":["/home/dev/dev/gravity-client/src/components/src/components/modal_babel.vue","/home/dev/dev/gravity-client/src/components/modal_babel.vue"],"names":[],"mappings":";AAiDA;EACC,iBAAA;CChDA;AACD,0DAA0D","file":"modal_babel.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.v-card__title\n\tmax-height: 48px\n",".v-card__title {\n  max-height: 48px;\n}\n/*# sourceMappingURL=src/components/modal_babel.css.map */"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-04cf5410","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./build/scramble/app-loader.js!./src/components/modal_babel.vue
// module id = Jaxt
// module chunks = 55